import React from "react";
import "./ErrorModal.css";
import {
  ConnectionLostIcon,
  UnexpectedErrorIcon,
  LoginFailedIcon,
  InvalidFileIcon,
  LargeFileIcon,
} from "./Icons";

const ERROR_CONFIG = {
  connection: {
    icon: <ConnectionLostIcon />,
    title: "Connection Lost",
    message:
      "Connection lost. Please check your internet connection and try again.",
    primaryBtn: "Try Again",
    showCancel: true,
  },
  
  server: {
    icon: <ConnectionLostIcon />, 
    title: "Server Connection Error",
    message:
      "We are unable to reach our servers at the moment. Please refresh the page or try again later.",
    primaryBtn: "Go Back",
    showCancel: true,
  },
  unexpected: {
    icon: <UnexpectedErrorIcon />,
    title: "Unexpected Error",
    message:
      "An unexpected error occurred. Please refresh the page or try again later.",
    primaryBtn: "Go Back",
    showCancel: true,
  },
  // ✨ NEW: Dedicated config for the daily scan limit
  scanLimit: {
    icon: <UnexpectedErrorIcon />, 
    title: "Daily Limit Reached",
    message: "You have reached your maximum number of scans for today. Please try again tomorrow.",
    primaryBtn: "Go Back",
    showCancel: false,
  },
  login: {
    icon: <LoginFailedIcon />,
    title: "Login Failed",
    message: "Incorrect email or password. Please try again.",
    primaryBtn: "Try Again",
    showCancel: true,
  },
  loginLimit: {
    icon: <LoginFailedIcon />, 
    title: "Too Many Attempts",
    // ✨ UPDATED: Removed the hardcoded "5 minutes". 
    // This now acts as a generic fallback if customMessage is missing.
    message: "Your account has been temporarily locked due to too many failed attempts. Please wait before trying again.",
    primaryBtn: "Understood",
    showCancel: false,
  },
  // The email belongs to a deleted (archived) or suspended account, so it can't be used to sign up
  inactiveAccount: {
    icon: <LoginFailedIcon />,
    title: "Inactive Account",
    message: "This email is currently linked to an inactive account.",
    primaryBtn: "OK",
    showCancel: false,
  },
  // Shown after you delete your own account and are signed out
  accountDeleted: {
    icon: <UnexpectedErrorIcon />,
    title: "Account Deleted",
    message: "Your account has been deleted and you've been signed out. To recover it, just log in again within 30 days.",
    primaryBtn: "OK",
    showCancel: false,
  },
  invalidFile: {
    icon: <InvalidFileIcon />,
    title: "We Can’t Open This File",
    message:
      "We couldn’t process the file or link you provided. Please make sure it is valid and supported, then try again.",
    primaryBtn: "Try Again",
    showCancel: false,
  },
  largeFile: {
    icon: <LargeFileIcon />,
    title: "File Too Large!",
    message:
      "File exceeds the maximum size limit. Please select a file that is under 100 MB.",
    primaryBtn: "Choose Another File",
    showCancel: true,
  },
  // The report's explanations could not be written (Groq down or rate-limited): no result is shown
  explainUnavailable: {
    icon: <UnexpectedErrorIcon />,
    title: "Explanations Unavailable",
    message:
      "Detailed explanations are temporarily unavailable. Please wait a few minutes and try again.",
    primaryBtn: "Try Again",
    showCancel: true,
  },
  explainBusy: {
    icon: <UnexpectedErrorIcon />,
    title: "Service Busy",
    message:
      "The explanation service is currently busy and has reached its usage limit. Please try again later.",
    primaryBtn: "Try Again",
    showCancel: true,
  },
};

const ErrorModal = ({
  isOpen,
  type,
  onClose,
  onPrimaryAction,
  customMessage,
}) => {
  if (!isOpen) return null;

  const config = ERROR_CONFIG[type];
  if (!config) return null;

  return (
    <div className="error-modal-backdrop">
      <div className="error-modal-container">
        <div className="error-icon-wrapper">{config.icon}</div>

        <div className="error-text-content">
          <h2 className="error-header">{config.title}</h2>
          {/* ✨ Your component already perfectly prioritizes the custom API message! */}
          <p className="error-message">{customMessage || config.message}</p>
        </div>

        <div className="error-actions">
          <button className="error-primary-btn" onClick={onPrimaryAction}>
            {config.primaryBtn}
          </button>

          {config.showCancel && (
            <button className="error-cancel-btn" onClick={onClose}>
              Cancel
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;